import React, { useEffect, useState } from "react";
import { MAIN_SITE_URL } from "../config";

const KEY = "ff:cookie-consent";

function CookieBanner() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    try {
      setStatus(localStorage.getItem(KEY));
    } catch {
      setStatus("granted");
    }
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch {}
    setStatus(value);
    window.dispatchEvent(new Event("ff:consent-changed"));
  };

  if (status === "granted" || status === "denied") return null;
  if (status === null) return null;

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
    >
      <div className="cookie-banner__inner">
        <p>
          We use cookies to run this site and, with your consent, analytics
          cookies to improve it. See our{" "}
          <a href={`${MAIN_SITE_URL}/privacy`}>Privacy Policy</a>.
        </p>
        <div className="cookie-banner__actions">
          <button
            type="button"
            className="loc-btn loc-btn--outline"
            onClick={() => decide("denied")}
          >
            Decline
          </button>
          <button
            type="button"
            className="loc-btn loc-btn--red"
            onClick={() => decide("granted")}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
